import React from 'react';
import BaseScadaNode from './BaseScadaNode';

export function TempGaugeSVG({ value, config = {}, width = 50, height = 70 }) {
    const v = parseFloat(value ?? 0);
    const min = parseFloat(config.min_value ?? -20);
    const max = parseFloat(config.max_value ?? 100);
    const pct = Math.min(1, Math.max(0, (v - min) / (max - min || 1)));
    const cx = width / 2;
    const bulbR = 8;
    const tubeW = 8;
    const tubeX = cx - tubeW / 2;
    const tubeY = 8;
    const tubeH = height - bulbR * 2 - 12;
    const fillH = tubeH * pct;
    const fillY = tubeY + tubeH - fillH;
    const color = v > (config.high_threshold ?? 60) ? '#EF4444' : v < (config.low_threshold ?? 0) ? '#3B82F6' : '#F59E0B';

    return (
        <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} style={{ display: 'block' }}>
            {/* Tube */}
            <rect x={tubeX} y={tubeY} width={tubeW} height={tubeH} rx={tubeW / 2} fill="#1E293B" stroke="#475569" strokeWidth={1.5} />
            {/* Fill */}
            <rect x={tubeX + 2} y={fillY} width={tubeW - 4} height={fillH} rx={(tubeW - 4) / 2} fill={color} />
            {/* Bulb */}
            <circle cx={cx} cy={height - bulbR - 2} r={bulbR} fill={color} stroke="#475569" strokeWidth={1.5} />
            {/* Value */}
            <text x={cx} y={tubeY - 2} textAnchor="middle" fill="#F1F5F9" fontSize={9}>
                {isNaN(v) ? '--' : `${v.toFixed(1)}${config.unit || '°C'}`}
            </text>
            {/* Tick marks */}
            {[0, 0.25, 0.5, 0.75, 1].map(t => (
                <line key={t}
                    x1={tubeX + tubeW} y1={tubeY + tubeH * (1 - t)}
                    x2={tubeX + tubeW + 4} y2={tubeY + tubeH * (1 - t)}
                    stroke="#475569" strokeWidth={1} />
            ))}
        </svg>
    );
}

export default function TemperatureGaugeNode(props) {
    const { data } = props;
    return (
        <BaseScadaNode {...props}>
            <TempGaugeSVG value={data?.liveValue} config={data?.config} width={data?.width || 50} height={data?.height || 70} />
            {data?.label && (
                <div style={{ textAlign: 'center', fontSize: 10, color: '#94A3B8', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                    {data.label}
                </div>
            )}
        </BaseScadaNode>
    );
}
